<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        SKU List
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        small
        v-if="checkPermission('app_sku_variant:b2b_sku_upload')"
        @click="$router.push('/sku-b2b-upload')"
        class="mr-8"
        >Add SKU</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="SKUOrder"
      :options.sync="options"
      :server-items-length="total"
      :loading="SKUOrderLoader"
      class="elevation-1 custom-icon-size mr-8"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col
                cols="12"
                sm="3"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @focus="fetchClientList"
                  @change="getwarehouse(selectedClient)"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="HS Code"
                  outlined
                  v-model="hscode"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="SKU Code"
                  outlined
                  v-model="sku"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Status"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                class="pr-4 pb-0"
                :sm="
                  userCategory.user_category === 1
                    ? '9'
                    : userCategory.user_category === 3 ||
                      userCategory.user_category === 6
                    ? '6'
                    : '6'
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.alternate_sku_one`]="{ item }">
        <span v-if="item.alternate_sku_one"
          >{{ item.alternate_sku_one }} {{ item.alternate_sku_two }}</span
        >
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        <span v-if="item.created_at">{{
          item.created_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        <span v-if="item.updated_at">{{
          item.updated_at | localMomentNew | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.unit_height`]="{ item }">
        {{ item.unit_height }} * {{ item.unit_width }} * {{ item.unit_length }}
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    SKUOrderLoader: false,
    warehouse_id: null,
    warehouses: [],
    selectedClient: null,
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    stores: [],
    hscode: null,
    sku: null,
    headers: [
      {
        text: "Client Name",
        value: "client_id__name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 100,
      },
      {
        text: "Warehouse",
        value: "warehouse_id__name",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Storer",
        value: "storer_id__channel_name",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "SKU Code",
        value: "sku_code",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Description",
        value: "description",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Innerpack",
        value: "innerpack",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Pallet",
        value: "pallet",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Packkey",
        value: "packkey",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Packkey Description",
        value: "packkey_description",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "HS Code",
        value: "hscode",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Alternate SKU",
        value: "alternate_sku_one",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Dimension",
        value: "unit_height",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Weight (In Kg)",
        value: "unit_weight",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Created By",
        value: "created_by__name",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Updated By",
        value: "updated_by__name",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },

      {
        text: "Packkey Status",
        value: "packkey_status",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Alt SKU Status",
        value: "altsku_status",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 100,
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      //   {
      //     text: "Actions",
      //     value: "actions",
      //     sortable: false,
      //     class: "body-1 font-weight-bold",
      //   },
    ],
    SKUOrder: [],
    options: {},
    total: 0,
    summary: false,
    order_number: null,
    filtersArr: {},
    clients: [],
    summaryData: {
      order_details: {},
      address: {},
      picking_and_dispatch_details: [
        {
          QTY_IN_ALLOCATED_STATUS: null,
          ORDER_QTY: null,
          ORDER_STATUS: null,
          QTY_IN_PICKED_STATUS: null,

          SHIPPED_QTY: null,
          SYSTEM_SHIP_DATE: null,
          TRUCK_SHIP_DATE: null,
        },
      ],
    },
    itemheaders: [
      { text: "Sku", value: "sku", sortable: false },
      {
        text: "External Line No",
        value: "externlineno",
        sortable: false,
        width: 200,
      },
      {
        text: "Allocation Strategy",
        value: "allocation_strategy",
        sortable: false,
      },
      { text: "Open Qty", value: "open_qty", sortable: false },
      { text: "Allocated Qty", value: "allocated_qty", sortable: false },
      { text: "Picked Qty", value: "picked_qty", sortable: false },
      { text: "Shipped Qty", value: "shipped_qty", sortable: false },

      { text: "Unit Price", value: "unit_price", sortable: false },

      { text: "UOM", value: "uom", sortable: false },
      { text: "Pack", value: "pack", sortable: false },
      { text: "Line", value: "line", sortable: false },

      { value: "status", text: "Status", sortable: false },
    ],
    orderDetails: [],
    statuses: ["Success", "Failed"],
    status: "",
    selectedItem: {},
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.getwarehouse(this.$store.getters.user.id);
    }
  },

  methods: {
    ...mapActions([
      "snackBar",

      "fetchClient",
      "inboundStatus",
      "getChannelDropdown",
      "getInforWarehouseListBB",
      "getWarehouseStores",

      "downloadSKUOrderItem",
      "getSKUB2BList",
    ]),

    downloadData(item) {
      this.downloadSKUOrderItem(item.id)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    getwarehouse(id) {
      this.warehouse = "";
      this.infor_storer_id = null;
      this.getInforWarehouseListBB(id).then((response) => {
        this.warehouses = response.data.result;
      });
    },
    getStores() {
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };

      this.getWarehouseStores(payload).then((res) => {
        this.stores = res.data;
      });
    },

    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },

    getlist() {
      this.getSKUB2BList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.SKUOrderLoader = false;
          this.SKUOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;

          this.total = res.data.total;
        })
        .catch(() => {
          this.SKUOrderLoader = false;
        });
    },

    tracking(id) {
      this.orderTracking(id).then((res) => {
        this.trackingDetails = res.data.data.records;
        this.reverseData = res.data.data.event_history;
        this.trackingPage = true;
      });
    },

    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        from_date: this.from_date,
        to_date: this.to_date,
        sku: this.sku,
        hscode: this.hscode,
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();

      this.getSKUB2BList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.SKUOrderLoader = false;
          this.SKUOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;

          this.total = res.data.total;
        })
        .catch(() => {
          this.SKUOrderLoader = false;
        });
    },
    clearAll() {
      this.order_key = "";
      this.selectedClient = "";
      this.from_date = "";
      this.to_date = "";
      this.receipt_no = "";
      this.status = "";
      this.infor_storer_id = "";
      this.warehouse_id = "";
      this.searchAll();
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}
</style>
